// Import utilities
const {
	isDefined
} = _uo.utility;

import { updateConditionPostData } from './';
import { sanitizeFieldAttributes } from '@builder/field/utilities';
import { restCall } from '@builder/common/utilities';

/**
 * Does a REST call to get the fields of a condition
 *
 * @param {Object} options                 The options
 * @param {String} options.integrationCode The unique code of the integration
 * @param {String} options.conditionCode   The unique code of the condition
 * @return {Promise}                       TRUE if it was successful
 */
const getAndSaveConditionFields = ( { integrationCode, conditionCode } ) => {
	return new Promise( ( resolve, reject ) => {

		// Do REST call to get the fields
		restCall(
			'actions_conditions_fields',

			// Data
			{
				integration: integrationCode,
				code: conditionCode
			},

			// On success
			( response ) => {
				// Check if the fields are defined
				if ( ! response.success || ! isDefined( response.fields ) ) {
					return reject( new Error( UncannyAutomator.i18n.conditions.errorCouldNotGetFields ) );
				}

				// Parse fields
				const fields = response.fields.map( ( fieldAttributes ) => {
					// Add the item type
					fieldAttributes.itemType = 'condition';

					// Add the integration ID
					fieldAttributes.integrationId = integrationCode;

					// Sanitize and return the attributes
					return sanitizeFieldAttributes( fieldAttributes );
				} );

				// Update the condition post data
				updateConditionPostData( {
					integrationCode: integrationCode,
					conditionCode: conditionCode,
					updates: {
						fields: fields
					}
				} );

				// Check if it was successful
				return resolve( fields );
			},

			// On fail
			() => {
				return reject( new Error( UncannyAutomator.i18n.conditions.errorCouldNotGetFields ) );
			},

			// Options
			{
				requiresRecipesObject: false,
				renderUI: false,
			}
		);

	} );
}

export default getAndSaveConditionFields;
